module.exports = __webpack_public_path__ + "img/banner-en40x80.ee37c168.jpg";